import { Component, ViewChild, Input, Output, EventEmitter , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IWorkflowUser, IWorkflowSecurity } from "../../interfaces/iworkflow";
import { WorkflowConfigurationService } from "../../services/workflowconfiguration.service";
import { FormControl } from "@angular/forms";
import { ModalDirective } from "../../directives/modal.directive";
import { Store } from "@ngrx/store";
import { IAppStore } from "../../iappstore";
import { SurpressLoadingAction, UnsurpressLoadingAction } from "../../actions/loading.action";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "usersearchmodal",
    templateUrl: "./usersearchmodal.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ModalDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UserSearchModalComponent {
    @ViewChild("usersearchmodal") public usersearchmodal: ModalDirective;
    @Input() existingUserList: IWorkflowSecurity[];
    @Input() containerName: string;
    @Input() includeGroups: boolean;
    @Output() selectedUsers: EventEmitter<any> = new EventEmitter<any>();
    usersSelected: IWorkflowSecurity[] = new Array();
    usersFound: IWorkflowSecurity[];
    searchTerm: FormControl;
    loading: boolean;
    userHasSearched: boolean;

    constructor(private workflowService: WorkflowConfigurationService, private store: Store<IAppStore>) {
        this.searchTerm = new FormControl();
        this.searchTerm.valueChanges
            .pipe(
                debounceTime(700),
                distinctUntilChanged()
            )
            .subscribe(term => {
                if (!term || term.trim().length === 0) {
                    this.usersFound = new Array();
                    return;
                }
                this.loading = true;
                this.userHasSearched = true;
                this.store.dispatch(new SurpressLoadingAction());
                this.workflowService.userSearch(term.trim(), this.includeGroups).subscribe((results: IWorkflowSecurity[]) => {
                    const userList: any = new Array();
                    results.forEach(r => {

                        const searchTerm: string = r && (r as IWorkflowUser).email  ? (r as IWorkflowUser).email : r.name;
                        // only show users which are not already associated to this workflow stage
                        // and are not already in the list of selected users.
                        if (!this.userExistsInList(this.usersSelected, searchTerm)
                            && !this.userExistsInList(this.existingUserList, searchTerm)) {
                            userList.push(r);
                        }
                    });
                    this.usersFound = userList;
                    this.store.dispatch(new UnsurpressLoadingAction());
                    this.loading = false;
                });
            });
    }

    openModal(): void {
        this.searchTerm.setValue("");
        this.userHasSearched = false;
        this.usersSelected = new Array();
        this.usersFound = new Array();
        this.loading = false;
        this.usersearchmodal.show();
    }

    closeModal(): void {
        this.usersearchmodal.hide();
    }

    private userExistsInList(userList: IWorkflowSecurity[], searchTerm: string): boolean {
        return userList.filter((u: IWorkflowSecurity) => {
            if (u as IWorkflowUser && (u as IWorkflowUser).email ) {
                return (u as IWorkflowUser).email  === searchTerm;
            } else {
                return u.name === searchTerm;
            }
        }).length > 0;
    }

    private userSelected(user: IWorkflowSecurity): void {
        if (user.selected) {
            this.usersSelected.push(user);
        } else {
            this.usersSelected.splice(this.usersSelected.indexOf(user));
        }
        this.usersSelected = this.reOrderUsers(this.usersSelected);
    }

    private removeSelectedUser(user: IWorkflowSecurity): void {
        user.selected = !user.selected;
        this.usersSelected.splice(this.usersSelected.indexOf(user), 1);
    }

    public addUsers(): void {
        // Store the newly selected users before adding them to existingUserList
        const newlySelectedUsers = [...this.usersSelected];
        
        this.usersSelected.forEach((u: IWorkflowUser) => {
            this.existingUserList.push(u);
        });
        this.existingUserList = this.reOrderUsers(this.existingUserList);
        
        // Emit only the newly selected users, not the entire list
        this.selectedUsers.emit(newlySelectedUsers);
        this.closeModal();
    }

    private reOrderUsers(users: IWorkflowSecurity[]): IWorkflowSecurity[] {
        return users.sort((a, b) => {
            if (a.name > b.name) {
                return 1;
            }

            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
    }
}

